import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import withErrorGuard from "../../../../HOC/withErrorGuard";
import { getVarsoUrl } from "../../../../common/helpers/helpers";
import { SingleWithLabelAndHelpText } from "../../../../components/atoms";
import { getClinGenSchemaProperties } from "../../../../state/selectors/ClinGen.selectors";
import ComponentPanel from "../../../../components/atoms/ComponentPanel/ComponentPanel";
import PublicationLinks from "../../../../components/Publications/components/PublicationLinks";
import HelperText from "../../../../components/atoms/HelperText";

const ClinGen = ({ clinGenSchema, data }) => {
  if (data && Object.keys(data || {}).length > 0 && clinGenSchema) {
    const {
      haploinsufficiency_desc: { label: haploInsufficiencyLabel },
      haploinsufficiency_score: { label: haploinsufficiencyScoreLabel },
      triplosensitivity_desc: { label: triplosensitivityDescLabel },
      triplosensitivity_score: { label: triplosensitivityScoreLabel },
      pub_med_references: { label: pubMedReferencesLabel },
      clingen_gene_id: { label: clingenGeneIdLabel },
    } = clinGenSchema.properties;

    const { title } = clinGenSchema;

    const tmpl = (
      <div className="varsome-horiz-flex">
        <SingleWithLabelAndHelpText
          item={data}
          prop="clingen_gene_id"
          label={clingenGeneIdLabel}
        />
        <SingleWithLabelAndHelpText
          item={data}
          prop="haploinsufficiency_desc"
          label={haploInsufficiencyLabel}
        />
        <SingleWithLabelAndHelpText
          item={data}
          prop="haploinsufficiency_score"
          label={haploinsufficiencyScoreLabel}
          crop={true}
        />
        <SingleWithLabelAndHelpText
          item={data}
          prop="triplosensitivity_desc"
          label={triplosensitivityDescLabel}
        />
        <SingleWithLabelAndHelpText
          item={data}
          prop="triplosensitivity_score"
          label={triplosensitivityScoreLabel}
          crop={true}
        />
        <div className="varsome-horiz-list-item">
          <div className="varsome-horiz-list-label">
            {pubMedReferencesLabel}
            <HelperText fieldDescriptionKey={pubMedReferencesLabel} />
          </div>
          <div className="varsome-horiz-list-value">
            {data.pub_med_references?.length ? (
              <PublicationLinks ids={data.pub_med_references} />
            ) : null}
          </div>
        </div>
      </div>
    );
    return (
      <div className="varsome-result-fixed" data-testid="clingen-component">
        <div className="varsome-container varsome-container__basic">
          <ComponentPanel
            title={title}
            version={data?.version}
            url={getVarsoUrl("https://clinicalgenome.org/")}
            helperPopup={<HelperText fieldDescriptionKey={title} />}
            content={tmpl}
          />
        </div>
      </div>
    );
  }
  return null;
};

ClinGen.propTypes = {
  data: PropTypes.shape({
    pub_med_references: PropTypes.arrayOf(PropTypes.number),
    clingen_gene_id: PropTypes.number,
    version: PropTypes.string,
  }),
  clinGenSchema: PropTypes.shape({
    title: PropTypes.string,
    properties: PropTypes.shape({
      pub_med_references: PropTypes.shape({
        label: PropTypes.string,
      }),
      clingen_gene_id: PropTypes.shape({
        label: PropTypes.string,
      }),
      haploinsufficiency_desc: PropTypes.shape({
        label: PropTypes.string,
      }),
      haploinsufficiency_score: PropTypes.shape({
        label: PropTypes.string,
      }),
      triplosensitivity_desc: PropTypes.shape({
        label: PropTypes.string,
      }),
      triplosensitivity_score: PropTypes.shape({
        label: PropTypes.string,
      }),
    }),
  }).isRequired,
};

ClinGen.defaultProps = {
  data: null,
};

const mapStateToProps = (state) => ({
  clinGenSchema: getClinGenSchemaProperties(state),
});

export default connect(
  mapStateToProps,
  null
)(withErrorGuard(ClinGen, "ClinGen", "ClinGen"));
